import React from 'react'
import thispc from '../icons/Computer.png'
import fileexpico from '../icons/fileExplorer.png'
import msstore from '../icons/Microsoft_Store_app_icon.png'
import spotify from '../icons/spotify.png'
import chrome from '../icons/chrome.png'
import vscode from '../icons/vscode.png'

const DesktopIcons = () => {
  return (
    <div className='desktop_Icon_Container flex flex-col p-1 space-y-2'>
        <div className='flex flex-col items-center w-20 min-h-20 hover:bg-gray-200 hover:bg-opacity-20 p-3 rounded-sm cursor-default space-y-1'>
            <img className='w-10' src={thispc} alt="desktopIcon" />
            <span className='text-xs font-medium text-center text-white'>This PC</span>
        </div>

        <div className='flex flex-col items-center w-20 min-h-20 hover:bg-gray-200 hover:bg-opacity-20 p-3 rounded-sm cursor-default space-y-1'>
            <img className='w-10' src={fileexpico} alt="desktopIcon" />
            <span className='text-xs font-medium text-center text-white'>File Explorer</span>
        </div>

        <div className='flex flex-col items-center w-20 min-h-20 hover:bg-gray-200 hover:bg-opacity-20 p-3 rounded-sm cursor-default space-y-1'>
            <img className='w-10' src={msstore} alt="desktopIcon" />
            <span className='text-xs font-medium text-center text-white'>Microsoft Store</span>
        </div>

        <div className='flex flex-col items-center w-20 min-h-20 hover:bg-gray-200 hover:bg-opacity-20 p-3 rounded-sm cursor-default space-y-1'>
            <img className='w-10' src={spotify} alt="desktopIcon" />
            <span className='text-xs font-medium text-center text-white'>spotify</span>
        </div>

        <div className='flex flex-col items-center w-20 min-h-20 hover:bg-gray-200 hover:bg-opacity-20 p-3 rounded-sm cursor-default space-y-1'>
            <img className='w-10' src={vscode} alt="desktopIcon" />
            <span className='text-xs font-medium text-center text-white'>Vs Code</span>
        </div>

        <div className='flex flex-col items-center w-20 min-h-20 hover:bg-gray-200 hover:bg-opacity-20 p-3 rounded-sm cursor-default space-y-1'>
            <img className='w-10' src={chrome} alt="desktopIcon" />
            <span className='text-xs font-medium text-center text-white'>Chrome</span>
        </div>

    </div>
  )
}

export default DesktopIcons
